export function autoPluralize(count, singular_string, plural_string=null){
    if (count > -1){
        let return_value = count.toString() + ' ';
        if (count !== 1) {
            if (plural_string) {
                return_value += plural_string;
            }else{
                return_value += singular_string + 's';
            }
        }else{
            return_value += singular_string;
        }
        return return_value;
    }
    if (plural_string) {
        return plural_string;
    }
    return singular_string + 's';
}
